export const lineHeightCoefficient = 1.286;
